import { z } from 'zod';
import {
  notificationStatusEnumSchema,
  notificationTypeEnumSchema,
  parentTableEnumSchema,
} from '../../shared/enums';

export const notificationListDataSchema = z.object({
  id: z.string().length(36),
  type: z.enum(notificationTypeEnumSchema.options).default('info'),
  title: z.string().max(255),
  description: z.string().nullable(),
  status: z.enum(notificationStatusEnumSchema.options).default('new'),
  parentTable: z
    .enum(parentTableEnumSchema.options)
    .default('contacts')
    .nullable(),
  parentRecordId: z.string().length(36).nullable(),

  createdAt: z.date(),
});

export type NotificationListData = z.infer<typeof notificationListDataSchema>;
